import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import Loader from "../../pages/Loader";

const AddPlan = () => {

  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);



  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();


  const onSubmit = async (data) => {
    try {
      setLoading(true);

      const formData = new FormData();
      const photoFile = data.photo[0];

      formData.append('file', photoFile);
      formData.append('upload_preset', 'prayagproperties');

      const cloudinaryResponse = await fetch(
        'https://api.cloudinary.com/v1_1/djmyigser/image/upload',
        {
          method: 'POST',
          body: formData
        }
      );

      const cloudinaryData = await cloudinaryResponse.json();
      if (!cloudinaryData.secure_url) {
        throw new Error('Failed to upload image to Cloudinary');
      }

      // Send to your backend
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/create_plans`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          title: data.title,
          photo: cloudinaryData.secure_url,
        }),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        Swal.fire({
          title: "Success!",
          text: "Plan created successfully.",
          icon: "success",
          confirmButtonColor: "#2563eb",
        });

        reset();
        setPreview(null);
      } else {
        Swal.fire({
          title: "Error",
          text: result.message || "Something went wrong.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Submission error:", error);
      Swal.fire({
        title: "Error",
        text: error.message || "Something went wrong.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  };

  return (
    <>
      <div className="w-full min-h-[75vh] flex items-center justify-center bg-gray-100 px-4">
        <div className="w-1/2 mx-auto p-4 sm:p-6 md:p-8 lg:p-10 bg-white shadow-xl">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-6 text-center">
            Add New Plan
          </h2>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            {/* Title Field */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Title <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                {...register("title", { required: "Title is required" })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter plan title"
              />
              {errors.title && (
                <p className="text-sm text-red-500 mt-1">
                  {errors.title.message}
                </p>
              )}
            </div>


            {/* Photo Upload */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Photo <span className="text-red-500">*</span>
              </label>
              <input
                type="file"
                accept="image/*"
                {...register("photo", {
                  required: "Photo is required",
                })}
                onChange={handleImageChange}
                className="block w-full text-sm text-gray-600
               file:mr-4 file:py-2 file:px-4
               file:rounded-md file:border-0
               file:text-sm file:font-medium
               file:bg-blue-50 file:text-blue-700
               hover:file:bg-blue-100"
              />
              {errors.photo && (
                <p className="text-sm text-red-500 mt-1">
                  {errors.photo.message}
                </p>
              )}
              {preview && (
                <div className="mt-4 flex justify-center sm:justify-start">
                  <img
                    src={preview}
                    alt="Preview"
                    className="w-32 h-32 object-cover rounded-xl border shadow-md"
                  />
                </div>
              )}
            </div>

            {/* Submit Button */}
            {/* <div>
              <button
                type="submit"
                className="w-full bg-blue-600 hover:bg-blue-700 text-white text-sm sm:text-base font-semibold py-2 px-4 rounded-lg transition-colors"
              >
                Submit Plan
              </button>
            </div> */}
            <div>
              <button
                type="submit"
                className="w-full bg-blue-600 hover:bg-blue-700 text-white text-sm sm:text-base font-semibold py-2 px-4 rounded-lg transition-colors flex items-center justify-center gap-2"
                disabled={loading}
              >
                {loading && (
                  <Loader/>
                )}
                {loading ? "Submitting..." : "Submit Plan"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddPlan;
